import { EPriceType } from '../../../../../../../../../packages/JsonQuery';
import { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { SingleSelectionAdvancedFilter } from 'shared/components/AdvancedFilter';
import { useFilterChangeCallback } from 'shared/hooks';
import { selectPriceTypeFilter } from 'shared/selectors/filters';

export const PriceTypeContainer: FC = () => {
  const { value, options } = useSelector(selectPriceTypeFilter);

  const onChange = useFilterChangeCallback();

  const handlePriceTypeChange = useCallback(
    (priceType: EPriceType) => {
      onChange({ action: 'setPriceType', arguments: [priceType === EPriceType.SM ? true : null] });
    },
    [onChange],
  );

  return <SingleSelectionAdvancedFilter value={value} options={options} onFilterChange={handlePriceTypeChange} />;
};
